export function compileArray(
  compiledValues: Array<string>
): string {
  return `[
  ${compiledValues.join(",\n")}
]`;
}
